import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'react-html-parser';
import {
    FacebookShareButton,
    FacebookShareCount,
    FacebookIcon,
    TwitterIcon,
    TwitterShareButton
} from 'react-share';
import moment from 'moment';

import { host } from "../../utils/globals";

const PartnerStoryPartial = ({ data, isEnglish, isAdditionalStory ,isPreview}) => {
    let shareUrl = `${host}/partner-story/${data.id}`;
    let className = isAdditionalStory ? 'additional-story' : '';
    return (
        <section id="news-events-detail" className={`col-md-12 col-xs-12 ${className}`}>
            <div className="news-events-title text-center">
                <div className={isPreview?"":"container"}>
                    <h1>
                        {data && isEnglish ? data.title : data && data.title_nepali || data.title}
                    </h1>
                    <ul className="list-unstyled list-inline text-center">
                        <li>
                            <a href={data && data.url} target="_blank">
                                <i className="fa fa-user"></i>
                                {data && data.source || data.submitted_by}
                            </a>
                        </li>
                        <li>
                            <i className="fa fa-calendar"></i>
                            {isPreview? moment().format("l"):data && data.published_date}
                        </li>
                    </ul>
                </div>
            </div>
            {
                data.image && (
                    <figure>
                        <img src={ isPreview?data.image:host + data.image} alt={data.title} />
                    </figure>
                )
            }
            <div className="page-share">
                <FacebookShareCount url={shareUrl}>
                    {shareCount => (
                        <div className="fbshareCout"><div className="counts">{shareCount}</div>  <div className="countText">Shares</div></div>
                    )}
                </FacebookShareCount>

                <FacebookShareButton url={shareUrl} >
                    <FacebookIcon size={30} /><span className="shareText"> Share on Facebook</span>
                </FacebookShareButton>

                <TwitterShareButton url={shareUrl} >
                    <TwitterIcon size={30} /> <span className="shareText"> Share on Twitter</span>
                </TwitterShareButton>
            </div>
            <div className="text-detail">
                {Parser(isEnglish ? data && data.details : data && data.details_nepali || data.details)}
            </div>
            <hr />
        </section>
    );
};

PartnerStoryPartial.propTypes = {
    data: PropTypes.object.isRequired,
    isEnglish: PropTypes.bool.isRequired,
    isAdditionalStory: PropTypes.bool
};

export default PartnerStoryPartial;